/* eslint-disable no-await-in-loop */
/* eslint no-param-reassign: ["error", { "props": false }] */
import { mapGetters, mapMutations } from 'vuex';
// import _ from 'lodash';
import Swal from 'sweetalert2';

const swalToast = Swal.mixin({
  toast: true,
  timer: 3000,
  showConfirmButton: false,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
  buttonsStyling: false,
});
export const webBleMixin = {
  computed: {
    ...mapGetters(['checkIsNewDevice', 'connectedDevices']),
  },
  data() {
    return {
      bleMsg: {
        Header: [255, 170],
        Footer: [187, 254],
        IntType: [48],
        FloatType: [49],
        StringType: [50],
        WeatherData: [51],
      },
      burnPercentage: {},
      needToReconnect: [],
      isManually: false,
    };
  },
  methods: {
    ...mapMutations([
      'addNewDevice',
      'removeDevice',
      'preConnectionNumberAdd',
      'preConnectionNumberMinus',
    ]),
    async scanAndConnect() {
      const options = {
        filters: [
          {
            namePrefix: 'FR_BLE_',
          },
        ],
        optionalServices: [0xffe0],
      };
      try {
        const bluetoothDevice = await navigator.bluetooth.requestDevice(options);
        if (bluetoothDevice.name in this.connectedDevices) {
          console.log('Already connected');
        } else {
          bluetoothDevice.addEventListener('gattserverdisconnected', this.onDisconnected);
          await this.connect(bluetoothDevice, false);
        }
      } catch (err) {
        console.log('user cancel', err);
      }
    },
    async connect(bluetoothDevice, autoConnect) {
      console.log('connect to ', bluetoothDevice.name);
      try {
        console.log('here in try?');
        const server = await bluetoothDevice.gatt.connect();
        console.log(server);
        if (!autoConnect) {
          this.preConnectionNumberAdd(1);
        }
        const service = await server.getPrimaryService(0xffe0);
        console.log(service);

        const Characteristic = await service.getCharacteristic(0xffe1);
        console.log(Characteristic);

        bluetoothDevice.Characteristic = Characteristic;
        bluetoothDevice.disconnectManually = false;
        await Characteristic.startNotifications();
        // this.setNotification(bluetoothDevice);
        console.log('測試1', bluetoothDevice);
        if (this.checkIsNewDevice(bluetoothDevice.name) && !autoConnect) {
          swalToast.fire({
            title: `<span>${bluetoothDevice.name} Connected.</span>`,
          });

          this.preConnectionNumberMinus(1);
        }
        this.addNewDevice({ name: bluetoothDevice.name, device: bluetoothDevice });
        return bluetoothDevice;
      } catch (err) {
        return new Error(`Connect to ${bluetoothDevice.name} failed`);
      }
    },
    delayer(time) {
      return new Promise((resolve) => {
        setTimeout(resolve, time);
      });
    },
    async onDisconnected(event) {
      // Object event.target is Bluetooth Device getting disconnected.
      console.log('> Bluetooth Device disconnected', event);
      console.log('isManually?', this.isManually);
      this.removeDevice(event.currentTarget.name);
      if (!this.isManually) {
        console.log('push devcie to not disconnected manully', event.currentTarget.name);

        await this.delayer(1000);

        await this.connect(event.currentTarget, true);

        // await this.connect(event.currentTarget);

        // this.connect(event.currentTarget);
      }
    },
    disconnect(device) {
      console.log(device);
      if (!device) {
        return;
      }
      this.isManually = true;
      if (device.gatt.connected) {
        device.gatt.disconnect();
        this.isManually = false;
      } else {
        console.log('> Bluetooth Device is already disconnected');
      }
    },
    parseRecieveData(data, device, callback) {
      console.log(`recieve from ${device.name} ${data}`);
      let reciveData;
      if (data.length > 1) {
        reciveData = data.map((el) => String.fromCharCode(el)).join('');
      } else {
        [reciveData] = data;
      }
      callback(reciveData, device);
      // if (_.isEqual(data.slice(0, 2), this.bleMsg.Header)
      //     && _.isEqual(data.slice(-2), this.bleMsg.Footer)) {
      //   // A communication with end byte
      //   switch (data[6]) {
      //     case 48: // Int
      //       reciveData = parseInt(
      //         data
      //           .slice(7, data.length - 2)
      //           .map((el) => String.fromCharCode(el))
      //           .join(''), 10,
      //       );
      //       callback(reciveData, device);
      //       break;
      //     case 49: // Float
      //       reciveData = parseFloat(
      //         data
      //           .slice(7, data.length - 2)
      //           .map((el) => String.fromCharCode(el))
      //           .join(''),
      //       );
      //       callback(reciveData, device);
      //       break;
      //     case 50: // String
      //       reciveData = data
      //         .slice(7, data.length - 2)
      //         .map((el) => String.fromCharCode(el))
      //         .join('');
      //       callback(reciveData, device);
      //       break;
      //     case 51:
      //       // weather
      //       console.log('weather: ', data.slice(6));
      //       break;
      //     default:
      //       callback('undefined', device);
      //       break;
      //   }
      // }
    },
    hexArrayToUnit8Array(hexArray) {
      const content = [];
      for (let i = 0; i < hexArray.length; i += 1) {
        content.push(parseInt(hexArray[i], 16));
      }
      return new Uint8Array(content);
    },
    decArrayToUnit8Array(hexArray) {
      const content = [];
      for (let i = 0; i < hexArray.length; i += 1) {
        content.push(hexArray[i]);
      }
      return new Uint8Array(content);
    },
    async send(dataType, device, msg) {
      console.log(device.name);
      const macLast4 = [255, 255, 255, 255];
      const convertData = msg
        .toString()
        .split('')
        .map((el) => el.charCodeAt(0));
      const hexContent = this.bleMsg.Header.concat(macLast4)
        .concat(this.bleMsg[dataType])
        .concat(convertData)
        .concat(this.bleMsg.Footer);
      console.log(hexContent);
      const content = this.decArrayToUnit8Array(hexContent);
      try {
        await device.Characteristic.writeValue(content);
      } catch (err) {
        return { success: false, msg: err };
      }
      return { success: true };
    },
    async sendRaw(device, content) {
      try {
        await device.Characteristic.writeValue(content);
        // console.log('data sent', content);
      } catch (err) {
        console.error('err happen', err, content);
        return new Error(err);
      }
      return 'finished writeValue';
    },
    AddListener(device, callback) {
      device.Characteristic.addEventListener('characteristicvaluechanged', (event) => {
        console.log('addlistener', event);
        const { value } = event.target;
        const decArray = [];
        for (let i = 0; i < value.byteLength; i += 1) {
          decArray.push(value.getUint8(i));
        }
        this.parseRecieveData(decArray, device, callback);
      });
    },
    removeListener(device) {
      device.Characteristic.removeEventListener('characteristicvaluechanged', () => {
        console.log('handleNotifications: removeListener');
      });
    },
    sendRawDataToDeviceAndWaitForRes(data, device, timeout) {
      const cmd = this.decArrayToUnit8Array([255, data, 254]);
      this.sendRaw(device, cmd);
      const promise = new Promise((resolve) => {
        setTimeout(() => {
          resolve(-1);
        }, timeout);
        // eslint-disable-next-line no-shadow
        const callback = (reciveData, device) => {
          console.log(reciveData, device);
          this.removeListener(device);
          resolve(reciveData);
        };
        this.AddListener(device, callback);
      });
      return promise;
    },
    sendDataToDeviceAndWaitForRes(datatype, data, device, timeout) {
      this.send(datatype, device, data);
      const promise = new Promise((resolve) => {
        setTimeout(() => {
          resolve(-1);
        }, timeout);
        // eslint-disable-next-line no-shadow
        const callback = (reciveData, device) => {
          console.log(reciveData, device);
          this.removeListener(device);
          resolve(reciveData);
        };
        this.AddListener(device, callback);
      });
      return promise;
    },
    createPromiseAndReturn(device, stringToCompare, step) {
      const promise = new Promise((resolve, reject) => {
        const eventListener = (event) => {
          const OKString = stringToCompare;
          const { value } = event.target;
          const hexArray = [];
          for (let i = 0; i < value.byteLength; i += 1) {
            hexArray.push(value.getUint8(i).toString(16));
          }
          console.log(hexArray);

          if (hexArray.join('') === OKString) {
            device.Characteristic.removeEventListener('characteristicvaluechanged', eventListener);
            setTimeout(() => {
              resolve(`${step} scuccess`);
            }, 200);
          }
          setTimeout(() => {
            reject(new Error(`${step} faile`));
          }, 2000);
        };
        device.Characteristic.addEventListener('characteristicvaluechanged', eventListener);
      });
      return promise;
    },
    // reset command 0x55 0xc8    後面為1毫秒
    sendRestCommand(device) {
      this.sendRaw(device, this.hexArrayToUnit8Array(['55', 'c8']));
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve('reset after 2 seconds');
        }, 200);
      });
    },
    sendGetSync(device, times = 5) {
      console.log('getSync');
      const syncPromise = this.createPromiseAndReturn(device, '1410', 'get sync');

      for (let i = 0; i < times; i += 1) {
        setTimeout(() => {
          this.sendRaw(device, this.hexArrayToUnit8Array(['30', '20']));
        }, i * 50);
      }
      return syncPromise;
    },
    sendGetSignature(device) {
      console.log('get signature');
      const promise = new Promise((resolve) => {
        const getSignatureListener = (event) => {
          const e300Signature = '141E950F10';
          const e310Signature = '141E951610';

          const { value } = event.target;
          const hexArray = [];
          for (let i = 0; i < value.byteLength; i += 1) {
            hexArray.push(value.getUint8(i).toString(16));
          }
          // console.log(hexArray)
          if (hexArray.join('').toUpperCase() === e300Signature) {
            device.Characteristic.removeEventListener(
              'characteristicvaluechanged',
              getSignatureListener,
            );
            resolve({ board: 'E300' });
          } else if (hexArray.join('').toUpperCase() === e310Signature) {
            device.Characteristic.removeEventListener(
              'characteristicvaluechanged',
              getSignatureListener,
            );
            resolve({ board: 'E310' });
          }
        };
        device.Characteristic.addEventListener('characteristicvaluechanged', getSignatureListener);
      });
      this.sendRaw(device, this.hexArrayToUnit8Array(['75', '20']));
      return promise;
    },
    async sendMovePointer(device, address) {
      const syncPromise = this.createPromiseAndReturn(device, '1410', 'pointer move');
      // console.log(address);
      this.sendRaw(device, this.hexArrayToUnit8Array(['55'].concat(address).concat(['20'])));
      console.log(`sent move pointer: ${address}`);
      return syncPromise;
    },
    chunkArray(myArray, chunkSize) {
      let index = 0;
      const arrayLength = myArray.length;
      const tempArray = [];

      for (index = 0; index < arrayLength; index += chunkSize) {
        const myChunk = myArray.slice(index, index + chunkSize);
        // Do something if you want with the group
        tempArray.push(myChunk);
      }
      return tempArray;
    },
    prepareHexPage(hex) {
      // take out data from intel hex

      console.log('hex!!!!!!!!!!!!!', hex);
      const data = hex
        .split(':')
        .map((el) => {
          const len = parseInt(el.slice(0, 2), 16);
          return el.slice(8, 8 + len * 2);
        })
        .join('');

      // split to 256
      const pageHex = data.match(/.{1,256}/g);

      // check last page and fill it with 'F'
      const lastPage = pageHex[pageHex.length - 1];
      pageHex[pageHex.length - 1] = lastPage
        + Array(256 - lastPage.length)
          .fill('F')
          .join('');

      return pageHex;
    },
    async writeToFlash(device, hexPage) {
      const syncPromise = this.createPromiseAndReturn(device, '1410', 'write page');
      const dataToSend = `64008046${hexPage}20`;
      const dataToSendHex = dataToSend.match(/.{1,2}/g);
      const pageChunk = this.chunkArray(dataToSendHex, 20);
      // console.log(dataToSendHex.length, pageChunk);

      for (let i = 0; i < pageChunk.length; i += 1) {
        await this.sendRaw(device, this.hexArrayToUnit8Array(pageChunk[i]));
      }
      return syncPromise;
    },
    async uploadHex(device, hex) {
      const hexPage = this.prepareHexPage(hex);
      let writeToFlashStatus = '';
      // console.log(hexPage);
      // here to emit upload progress
      const percentagePerPage = 100 / hexPage.length;
      for (let page = 0; page < hexPage.length; page += 1) {
        let address = ((page * 128) / 2).toString(16);
        address = Array(4 - address.length)
          .fill(0)
          .join('') + address;
        address = address.match(/.{1,2}/g).reverse();
        const movePointerStatus = await this.sendMovePointer(device, address);
        console.log(movePointerStatus);

        writeToFlashStatus = await this.writeToFlash(device, hexPage[page]);
        console.log(writeToFlashStatus);
        this.$set(this.burnPercentage, device.name, Math.floor(percentagePerPage * page));
      }
      return writeToFlashStatus;
    },
    async uploadFW(device, code) {
      console.log('Here to start upload FW');
      // eslint-disable-next-line no-unused-vars
      let hexCode = '';
      if (typeof code === 'object') {
        hexCode = code.hexData;
      } else {
        hexCode = code;
      }
      // let tempCode = hexRed;
      console.log(device);
      const resetResponse = await this.sendRestCommand(device);
      console.log(resetResponse);
      const getSyncResponse = await this.sendGetSync(device);
      const getSignatureResponse = await this.sendGetSignature(device);
      console.log(getSyncResponse, getSignatureResponse);
      const uploadStatus = await this.uploadHex(device, hexCode);
      this.$set(this.burnPercentage, device.name, 100);
      console.log(uploadStatus);
      return uploadStatus;
    },
  },
};

export default webBleMixin;
